import { makeStyles } from '@material-ui/core';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type FinanceProductGridElementClasses =
  | 'container'
  | 'cacheContainer'
  | 'mobileDivider'
  | 'divider'
  | 'gridElement'
  | 'priceDisplayElement'
  | 'multiCurrency';

const financeProductGridElementStyles = makeStyles<ISpcTheme, FinanceProductGridElementClasses>(
  theme => ({
    container: {
      display: 'flex',
      justifyContent: 'flex-start',

      [theme.breakpoints.down('md')]: {
        justifyContent: 'center',
      },
    },
    cacheContainer: {},
    mobileDivider: {
      display: 'none',
      [theme.breakpoints.down('md')]: {
        display: 'block',
        height: '85px',
        margin: '0px 5px',
      },
      [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
        position: 'relative',
        height: '95px',
        margin: '0px 2px',
      },
    },
    divider: {
      height: '85px',
      marginLeft: 20,

      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    gridElement: {
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
    priceDisplayElement: {
      display: 'flex',
      [theme.breakpoints.down('xs')]: {
        flex: 1,
        flexBasis: 'auto',
      },
    },
    multiCurrency: {
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
  }),
  { name: 'Customise_FinanceProductGridElement' },
);

export default financeProductGridElementStyles;
